import React, { useRef, useEffect, useState } from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { action_global_get_init_country_message } from '../../../../../store/actions/pages/policy'
import { useSelector } from 'react-redux'
import Header from "../../fragments/heading/index";
import { FormattedMessage } from 'react-intl'
import Affix from '../../../../components/affix'
import { useApp } from '../../../../hooks/common'
import withObserver from '../../../moduleable/modules/hoc/withObserver'
import AutoSwiper from '../../../../components/swiper/autowidth'
import { useMemo } from 'react'

const BonusItem = withObserver(props =>{
    const { data, innerRef } = props;
    const global = useSelector(state=>state.global);
    const { config } = global;

    const messageData = useMemo(() =>{
        if(data.content){
            let message = data.content;
            message = message.replace(/#siteLabel/g, config?.name);
            return message;
        }else{
            return null;
        }
    },[data.content])

    return <div id={data?.id} ref={innerRef}>
        {
            data?.content && <div dangerouslySetInnerHTML={{ __html : messageData }}></div>
        }
    </div>
})

const TopNavigation = props => {
    useStyles(classes)
    const {modules, moduleSelect, currentModule } = props
    const [swiper, setSwiper] = useState()
    const clickingRef = useRef()
    
    const clickHandle = (s, e) => {
        clickingRef.current = true
       if(s.clickedIndex === s.activeIndex || s.clickedIndex === s.activeIndex+1){
           s.slidePrev(300)
       }else{
            s.slideNext(300)
       }

       setTimeout(() => {
        clickingRef.current = false
       }, 1000)

    }

    useEffect(() => {
        if(!clickingRef.current){
            if(swiper){
                const currentIndex = modules?.sort((s1, s2) => s1.sort - s2.sort)?.filter(s=>!!s.name)?.map((s, index)=>{return {...s, index}})?.find(m => m.id === currentModule)?.index
                swiper.slideTo(currentIndex, 300)
            }
        }
        
    }, [currentModule])


    return <AutoSwiper options={{
        slidesPerView: 'auto',
        onSwiper: setSwiper,
        onClick: clickHandle,
        watchSlidesVisibility : true,
		slideVisibleClass: 'swiper-visible'
    }} className={classes.TopNavigation} items={modules} render={(item, index) => {
        return <div className={`${classes.Navigation} ${currentModule === item.id?classes.Active:''}`} onClick={() => { moduleSelect(item) }}><span>{item.name}</span></div>
        
    }} />
}

const BaseLayout = props =>{
    const { modules, currentModule, moduleSelect } = props;
    const isApp = useApp()

    const navs = modules?.filter(s => !!s.name)

    return <React.Fragment>
        {
            navs?.length > 0 && <Affix offsetTop={isApp?0:44}>
                <TopNavigation modules={navs} currentModule={currentModule} moduleSelect={moduleSelect} />
            </Affix>
        }
        
        {props.children}
    </React.Fragment>
}


const BonusPoint = props => {
    useStyles(classes)
    const pagePolicy = useSelector(state=>state.pagePolicy);
    const [currentModule, setCurrentModule] = useState(pagePolicy?.bonusPoint?.modules?.find(s => !!s.name)?.id)
    const idRef = useRef(null)
    const scrollRef = useRef(true)

    const moduleSelect = m => {
        setCurrentModule(m.id)
        scrollRef.current = false
        if(idRef.current){
            clearTimeout(idRef.current)
        }
        document.getElementById(m.id)?.scrollIntoView?.({
            behavior: 'smooth',
        })

        idRef.current = setTimeout(() => {
            scrollRef.current = true
        }, 2000)
    }

    const viewHandle = entry => {
        if(scrollRef.current){
            if (entry) {
                const element = entry.target
                if (element) {
                    const curr = pagePolicy?.bonusPoint?.modules?.find(s => s.id === element?.id)
                    if(curr && curr.name){
                        setCurrentModule(element?.id)
                    }
                }
            }
        }
    }

    return <React.Fragment>
        <Header centerSlot={<FormattedMessage id="bonus_points" defaultMessage="Bonus Points" />} />

        <BaseLayout modules={pagePolicy?.bonusPoint?.modules} moduleSelect={moduleSelect} currentModule={currentModule}>
            <div className={classes.Container}>
                <div className="point-container">
                    {
                        pagePolicy?.bonusPoint?.banner && <div dangerouslySetInnerHTML={{ __html: pagePolicy?.bonusPoint?.banner }}></div>
                    }

                    <div className="font-container">
                        {
                            pagePolicy?.bonusPoint?.modules?.map((item, index) =><BonusItem data={item} key={index} entryView={viewHandle} />)
                        }
                    </div>
                </div>
            </div>
        </BaseLayout>
    </React.Fragment>
}

BonusPoint.fetchData = async (store, params, search, headers) => {
    // let data = {
    //     bonusPoint:{
    //         "banner":"<div class=\"_image\"> <a href=\"\"> <img class=\"global-display-none-pc\" src=\"https://image.geeko.ltd/chicme/20220112/m-bg.jpg\" alt=\"discount\" /> </a> </div>",
    //         "modules":[
    //             {
    //                 "id":"module-1",
    //                 "name":"What's the points?",
    //                 "content":"<div class=\"_container module\"> <span class=\"_num global-display-none-msite\"> <span> 1 </span> </span> <p class=\"global-title txtc\"> What's the points? </p> <p class=\"global-font\"> Points are a kind of virtual currency on the #siteLabel website. You can choose to use and deduct part of the payment amount when placing an order. </p> </div>"
    //             },
    //             {
    //                 "id":"module-2",
    //                 "name":"How to use points?",
    //                 "content":"<div class=\"global-marginTop _container module\"> <span class=\"_num global-display-none-msite\"> <span> 2 </span> </span> <p class=\"global-title txtc\"> How to use points? </p> <ul class=\"myul\"> <li> 1.Every 100 points = $1 USD </li> <li> 2.You can use the points to deduct up to 50% of the total amount of products when you place your order (only the total price of products is supported, excluding shipping, insurance). </li> <li> 3. Points are valid from 7 days to 3 months, if your points expired before being used, they will be deleted from your account. </li> </ul> </div>"
    //             },
    //             {
    //                 "id":"module-3",
    //                 "name":"How to earn points?",
    //                 "content":"<div class=\"earn-points global-marginTop module\" id=\"earnPoints\"> <p class=\"global-title txtc points-policy-txtc\"> How to earn points? </p> <div class=\"__content\"> <div class=\"__first\"> <div class=\"flex-container\" style=\"margin-top: 16px;\"> <div class=\"icon-left\"> <span> <span class=\"iconfont\"> &#xe6cd; </span> </span> </div> <div class=\"font-right\"> <p class=\"_title\"> Register with ChicMe </p> <p class=\"_font\"> New customer complete the registration will receive 100 points. </p> </div> </div> <div class=\"flex-container\"> <div class=\"icon-left\"> <span> <span class=\"iconfont\" style=\"font-size: 34px;\"> &#xe7ea; </span> </span> </div> <div> <p class=\"_title\"> Verify your email </p> <p class=\"_font\"> You may verify your email on your profile page to receive 100 points. </p> </div> </div> </div> <div class=\"flex-container\"> <div class=\"icon-left\"> <span> <span class=\"iconfont\"> &#xe7ec; </span> </span> </div> <div> <p class=\"_title\"> Buy and Earn </p> <p class=\"_font\"> You’ll earn 1 point for every dollar spent on your purchase. </p> <p class=\"_font global-marginTop-20\"> 1.Points will be credited to your account once you confirm delivery of your order. </p> <p class=\"_font global-marginTop-20\"> 2.Log into your #siteLabel account </p> <p class=\"_font global-marginTop-20\"> 3.Click on \"My Orders\" </p> <p class=\"_font global-marginTop-20\"> 4.Select orders you have received and click on \"Confirm order \" </p> </div> </div> <div class=\"flex-container\"> <div class=\"icon-left\"> <span> <span class=\"iconfont\"> &#xe6d1; </span> </span> </div> <div> <p class=\"_title\"> Review our products </p> <p class=\"_font\"> Points can be earned by posting comments and reviews on purchased items. After meeting the minumum of text product comments, you will receive points. </p> <div class=\"m-table global-display-none-msite\" style=\"border-collapse: collapse;margin-top: 20px;width: 100%;\"> <div class=\"m-table-row border-header\"> <div class=\"m-table-cell\"> Post a comment </div> <div class=\"m-table-cell\"> Post a comment with size information </div> <div class=\"m-table-cell\"> Post a comment with pictures </div> </div> <div class=\"m-table-row border-content\"> <div class=\"m-table-cell\"> <span> 30 </span> </div> <div class=\"m-table-cell\"> 50 </div> <div class=\"m-table-cell\"> 100 </div> </div> </div> <div class=\"m-table global-display-none-pc\" style=\"border-collapse: collapse;margin-top: 20px;width: 100%;border: 1px solid #e7cda4;\"> <div class=\"m-table-row\" style=\"border: 1px solid #e7cda4;\"> <div class=\"m-table-cell m-vertical-middle\" style=\"background-color: #f4e9d1;padding: 10px 5px;\"> Post a comment </div> <div class=\"m-table-cell txtc m-vertical-middle\" style=\"width: 60px;\"> <span> 30 </span> </div> </div> <div class=\"m-table-row\" style=\"border: 1px solid #e7cda4;\"> <div class=\"m-table-cell m-vertical-middle\" style=\"background-color: #f4e9d1;padding: 10px 5px;\"> Post a comment with size information </div> <div class=\"m-table-cell txtc m-vertical-middle\" style=\"width: 60px;\"> 50 </div> </div> <div class=\"m-table-row\" style=\"border: 1px solid #e7cda4;\"> <div class=\"m-table-cell m-vertical-middle\" style=\"background-color: #f4e9d1;padding: 10px 5px;\"> Post a comment with pictures </div> <div class=\"m-table-cell txtc m-vertical-middle\" style=\"width: 60px;\"> 100 </div> </div> </div> <p class=\"_font global-marginTop-20\"> 1.Log into your #siteLabel account </p> <p class=\"_font global-marginTop-20\"> 2.Click on \"My Orders\" </p> <p class=\"_font global-marginTop-20\"> 3.Go to \"View Details\" of the order containing the item you want to review </p> <p class=\"_font global-marginTop-20\"> 4.Then click \"Write a Review\" and upload a photo if you wish </p> <p class=\"_font global-marginTop-20\"> 5.Submit your reviews for verification </p> <div class=\"notes global-marginTop-20\"> <p class=\"_title\" style=\"font-size: 14px\"> 6.NOTES: </p> <ul class=\"_conatiner\" style=\"margin-top: 0px;\"> <li class=\"_font\"> Your review will appear on product page after it has been verified by our staff. </li> <li class=\"_font\"> Please note that you can receive a maximum of 2000 points through comments daily </li> </ul> </div> </div> </div> <div class=\"flex-container\"> <div class=\"icon-left\"> <span> <span class=\"iconfont\"> &#xe6d0; </span> </span> </div> <div> <p class=\"_title\"> Make suggestions </p> <p class=\"_font\"> You can send us your suggestions by using the \"Suggestion & Error Report\" option under \"Settings“/\"Your account\", accepted suggestions will earn 200 points. </p> </div> </div> <div class=\"flex-container\"> <div class=\"icon-left\"> <span> <span class=\"iconfont\"> &#xe6cf; </span> </span> </div> <div> <p class=\"_title\"> Participate in Survey </p> <p class=\"_font\"> You can earn 150 points for participating in survey. </p> </div> </div> <div class=\"flex-container\"> <div class=\"icon-left\"> <span> <span class=\"iconfont\"> &#xe6cc; </span> </span> </div> <div> <div class=\"activities\"> <p class=\"_title\"> Participate in activities </p> <p class=\"_font\"> Scan QR code to open APP, or search #siteLabel on APP store or Google Play to join the following campaigns. You can get more points. </p> <div class=\"_image\"> <img src=\"https://image.geeko.ltd/chicme/20210415/code.png\" alt=\"AppDownLoad\"> </div> </div> <p class=\"_title global-marginTop global-marginTop-20\"> Join in the C-Log activities </p> <p class=\"_font\"> You will get 300 points for posting videos or photos on c-log with at least 50 words. </p> <p class=\"_title global-marginTop global-marginTop-20\"> Participate in daily marketing activities </p> <p class=\"_font\"> Participate in the points-related activities held by Site or by official social media accounts (ins: chicmeofficial, fb: Chic Me) within the specified time limit, and receive the corresponding points rewards according to the activity rules. </p> </div> </div> <div class=\"flex-container\"> <div class=\"icon-left\"> <span> <span class=\"iconfont\"> &#xe7eb; </span> </span> </div> <div> <p class=\"_title\"> Refer a Friend </p> <p class=\"_font\"> 1. If customers want to earn mentioned Points Reward, the referred person must be a new customer. </p> <p class=\"_font global-marginTop-20\"> 2. Complete registration on https://www.chicme.com by referral link，referring customers will earn 300 points, and your friend will get 500 points. </p> <p class=\"_font global-marginTop-20\"> 3. Complete registration in APP with the referral invitation code, referring customers will earn 500 points, and your friend will get 1000 points. </p> </div> </div> </div> </div>"
    //             },
    //             {
    //                 "id":"module-4",
    //                 "name":"How to check points?",
    //                 "content":"<div class=\"global-marginTop module\"> <p class=\"global-title\"> How to check points? </p> <p class=\"global-font\"> Please log into your #siteLabel account and click on \"My Points/Points\" in your personal account to view the balance. </p> </div>"
    //             },
    //             {
    //                 "id":"module-5",
    //                 "name":"About returning ChicMe points",
    //                 "content":"<div class=\"global-marginTop module\"> <p class=\"global-title\"> About returning ChicMe points </p> <p class=\"global-font\"> 1. If an unpaid order is cancelled, the points applied to the original order will be immediately returned to your points account. </p> <p class=\"global-font global-marginTop-20\"> 2. If you request a return/a full refund for a product, the points for returned item will reverted to your account along with your refund.If it's a partial return, points will be returned based on a percentage of the product's price. </p> <p class=\"global-font global-marginTop-20\"> 3. The validity period of the points is calculated from the date when the points are first obtained, and will not be re-timed due to the points being returned. </p> </div>"
    //             }
    //         ]
    //     }
    // };
    await store.dispatch(action_global_get_init_country_message("M1713", "bonusPoint", headers))
}

export default BonusPoint
